// extracted by css-extract-rspack-plugin
export default {"dealers_table":"xEgH8Qs8zXcfKqJ8","actionsRow":"ulPprNkgtSANHPXi","person_list":"OBmn6htCPnIWjOX0"};